<template>
  <div>
    <source-layer v-model="sourceLayer" :validated="validated"></source-layer>

    <b-row v-if="validated && objectsRelationIsEmpty">
      <b-col offset="3" cols="9">
        <small class="text-danger">
            Należy wybrać relację między obiektami.
        </small>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="3">
        <label for="objectsRelationSelect">Gdzie obiekty</label>
      </b-col>
      <b-col cols="9">
        <b-form-select id="objectsRelationSelect" v-model="objectsRelation" :options="objectsRelations" :state="validated && objectsRelationIsEmpty ? false : null">
          <template slot="first">
            <option :value="null">Wybierz</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <reference-layer v-model="referenceLayerId" :reference-layers="referenceLayers" :showErrorInfo="validated && referenceLayerIsEmpty"></reference-layer>
  </div>
</template>

<script>
import SourceLayer from './SourceLayer';
import ReferenceLayer from './ReferenceLayer';
import { FEATURES_GEOMETRY_ANALYSIS } from '../../store/actions.type';
import { WINDOW_NOTIFICATION_SHOW } from '../../store/mutations.type';

export default {
  components: {
    SourceLayer,
    ReferenceLayer
  },
  data() {
    return {
      sourceLayer: null,
      referenceLayerId: null,
      objectsRelations: [
        { text: 'Zawierają się', value: 'zawieraja' },
        { text: 'Przecinają', value: 'przecinaja' },
        { text: 'Stykają się na granicy', value: 'stykaja_na_granicy' }
      ],
      objectsRelation: null,
      validated: false,
      waitingForResponse: Boolean
    }
  },
  props: {
    referenceLayers: { type: Array, default: () => [] },
    hasErrors: { type: Boolean, default: false }
  },
  computed: {
    sourceLayerTypeIsEmpty() {
      return !this.sourceLayer;
    },
    objectsRelationIsEmpty() {
      return !this.objectsRelation;
    },
    referenceLayerIsEmpty() {
      return !this.referenceLayerId;
    },
    formHasErrors() {
      return this.sourceLayerTypeIsEmpty || this.objectsRelationIsEmpty || this.referenceLayerIsEmpty;
    }
  },
  watch: {
    formHasErrors(value) {
       this.$emit('update:hasErrors', value);
    }
  },
  methods: {
    async submit() {
      this.validated = true;

      if (!this.formHasErrors) {
        const analysisData = {
          typ_wejsciowych: this.referenceLayerId.type,
          typ_analizy: this.objectsRelation,
          warstwa_id: this.referenceLayerId.id,
          features_geojson: this.referenceLayerId.geojson
        };

        if (this.sourceLayer.type === 'selection') {
            analysisData.feature_ids_filter = [...this.$store.getters.selectedMapFeatures];

          if (!analysisData.feature_ids_filter.length) {
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              type: "warn",
              title: "Uwaga. Nie zaznaczono obiektów.",
              message: "Nie można wykonać analizy z powodu braku zaznaczonych obiektów.",
              duration: 5000
            });

            return;
          }
        }
        
        this.$emit('update:waitingForResponse', true);
        await this.$store.dispatch(FEATURES_GEOMETRY_ANALYSIS, analysisData);
        this.$emit('update:waitingForResponse', false);
      } 
      else {
        this.$emit('update:hasErrors', true);
      }
    }
  }
}
</script>
